export const colombiaDepartments = [
  {
    "name": "LA GUAJIRA",
    "cities": [
      "URIBIA",
      "MANAURE",
      "MAICAO",
      "RIOHACHA",
      "DIBULLA",
      "HATONUEVO",
      "BARRANCAS",
      "DISTRACCION",
      "FONSECA",
      "SAN JUAN DEL CESAR",
      "VILLANUEVA",
      "EL MOLINO",
      "URUMITA",
      "LA JAGUA DEL PILAR",
      "ALBANIA"
    ]
  },
  {
    "name": "MAGDALENA",
    "cities": [
      "SANTA MARTA",
      "CIENAGA",
      "SITIONUEVO",
      "PUEBLOVIEJO",
      "ARACATACA",
      "EL RETEN",
      "REMOLINO",
      "PIVIJAY",
      "FUNDACION",
      "SALAMINA",
      "EL PIÑON",
      "CERRO SAN ANTONIO",
      "PEDRAZA",
      "CHIVOLO",
      "TENERIFE",
      "PLATO",
      "ARIGUAINI",
      "SANTA ANA",
      "PIJIÑO DEL CARMEN",
      "SAN SEBASTIAN DE BUENAVISTA",
      "SAN ZENON",
      "GUAMAL",
      "EL BANCO",
      "ZONA BANANERA",
      "ALGARROBO",
      "CONCORDIA",
      "ZAPAYAN",
      "SABANAS DE SAN ANGEL",
      "NUEVA GRANADA",
      "SANTA BARBARA DE PINTO"
    ]
  },
  {
    "name": "ATLANTICO",
    "cities": [
      "BARRANQUILLA",
      "PUERTO COLOMBIA",
      "TUBARA",
      "GALAPA",
      "SOLEDAD",
      "MALAMBO",
      "JUAN DE ACOSTA",
      "BARANOA",
      "SABANAGRANDE",
      "POLONUEVO",
      "PIOJO",
      "USIACURI",
      "SANTO TOMAS",
      "PALMAR DE VARELA",
      "SABANALARGA",
      "PONEDERA",
      "LURUACO",
      "REPELON",
      "CANDELARIA",
      "MANATI",
      "CAMPO DE LA CRUZ",
      "SANTA LUCIA",
      "SUAN"
    ]
  },
  {
    "name": "CESAR",
    "cities": [
      "VALLEDUPAR",
      "PUEBLO BELLO",
      "LA PAZ",
      "MANAURE",
      "EL COPEY",
      "SAN DIEGO",
      "AGUSTIN CODAZZI",
      "BOSCONIA",
      "BECERRIL",
      "EL PASO",
      "LA JAGUA DE IBIRICO",
      "CHIRIGUANA",
      "ASTREA",
      "CHIMICHAGUA",
      "CURUMANI",
      "TAMALAMEQUE",
      "PAILITAS",
      "PELAYA",
      "LA GLORIA",
      "AGUACHICA",
      "GAMARRA",
      "GONZALEZ",
      "RIO DE ORO",
      "SAN MARTIN",
      "SAN ALBERTO"
    ]
  },
  {
    "name": "BOLIVAR",
    "cities": [
      "SANTA CATALINA",
      "CARTAGENA",
      "CLEMENCIA",
      "SANTA ROSA",
      "VILLANUEVA",
      "SAN ESTANISLAO",
      "SOPLAVIENTO",
      "SAN CRISTOBAL",
      "TURBACO",
      "CALAMAR",
      "ARJONA",
      "MAHATES",
      "TURBANA",
      "EL GUAMO",
      "SAN JUAN NEPOMUCENO",
      "MARIA LA BAJA",
      "SAN JACINTO",
      "EL CARMEN DE BOLIVAR",
      "ZAMBRANO",
      "CORDOBA",
      "MAGANGUE",
      "TALAIGUA NUEVO",
      "MOMPOS",
      "CICUCO",
      "SAN FERNANDO",
      "MARGARITA",
      "PINILLOS",
      "HATILLO DE LOBA",
      "EL PEÑON",
      "SAN MARTIN DE LOBA",
      "BARRANCO DE LOBA",
      "ALTOS DEL ROSARIO",
      "REGIDOR",
      "ACHI",
      "RIO VIEJO",
      "TIQUISIO",
      "MORALES",
      "MONTECRISTO",
      "SAN JACINTO DEL CAUCA",
      "ARENAL",
      "SIMITI",
      "SANTA ROSA DEL SUR",
      "SAN PABLO",
      "CANTAGALLO",
      "ARROYOHONDO"
    ]
  },
  {
    "name": "SUCRE",
    "cities": [
      "SAN ONOFRE",
      "OVEJAS",
      "CHALAN",
      "TOLUVIEJO",
      "COLOSO",
      "SAN PEDRO",
      "LOS PALMITOS",
      "MORROA",
      "BUENAVISTA",
      "SINCELEJO",
      "SINCE",
      "PALMITO",
      "SAN JUAN DE BETULIA",
      "COROZAL",
      "SAMPUES",
      "GALERAS",
      "SAN BENITO ABAD",
      "SUCRE",
      "CAIMITO",
      "LA UNION",
      "MAJAGUAL",
      "SAN MARCOS",
      "GUARANDA",
      "EL ROBLE",
      "TOLU",
      "COVEÑAS"
    ]
  },
  {
    "name": "CORDOBA",
    "cities": [
      "SAN ANTERO",
      "SAN BERNARDO DEL VIENTO",
      "MOÑITOS",
      "LORICA",
      "PURISIMA",
      "MOMIL",
      "SAN ANDRES DE SOTAVENTO",
      "CHIMA",
      "COTORRA",
      "CHINU",
      "PUERTO ESCONDIDO",
      "SAN PELAYO",
      "CIENAGA DE ORO",
      "SAHAGUN",
      "LOS CORDOBAS",
      "CERETE",
      "MONTERIA",
      "SAN CARLOS",
      "CANALETE",
      "PUEBLO NUEVO",
      "PLANETA RICA",
      "AYAPEL",
      "VALENCIA",
      "BUENAVISTA",
      "TIERRALTA",
      "MONTELIBANO",
      "LA APARTADA",
      "PUERTO LIBERTADOR"
    ]
  },
  {
    "name": "NORTE DE SANTANDER",
    "cities": [
      "EL CARMEN",
      "CONVENCION",
      "TEORAMA",
      "TIBU",
      "EL TARRA",
      "SAN CALIXTO",
      "HACARI",
      "SARDINATA",
      "CUCUTA",
      "OCAÑA",
      "PUERTO SANTANDER",
      "LA PLAYA",
      "EL ZULIA",
      "ABREGO",
      "BUCARASICA",
      "VILLA CARO",
      "LOURDES",
      "GRAMALOTE",
      "SANTIAGO",
      "SAN CAYETANO",
      "SALAZAR",
      "VILLA DEL ROSARIO",
      "CACHIRA",
      "DURANIA",
      "LOS PATIOS",
      "LA ESPERANZA",
      "BOCHALEMA",
      "ARBOLEDAS",
      "CHINACOTA",
      "RAGONVALIA",
      "CUCUTILLA",
      "PAMPLONITA",
      "HERRAN",
      "TOLEDO",
      "PAMPLONA",
      "LABATECA",
      "MUTISCUA",
      "CACOTA",
      "SILOS",
      "CHITAGA"
    ]
  },
  {
    "name": "ANTIOQUIA",
    "cities": [
      "ARBOLETES",
      "SAN JUAN DE URABA",
      "NECOCLI",
      "SAN PEDRO DE URABA",
      "TURBO",
      "NECHI",
      "EL BAGRE",
      "APARTADO",
      "CAUCASIA",
      "CACERES",
      "CAREPA",
      "CHIGORODO",
      "TARAZA",
      "ZARAGOZA",
      "SEGOVIA",
      "ANORI",
      "VALDIVIA",
      "ITUANGO",
      "AMALFI",
      "YONDO",
      "REMEDIOS",
      "YARUMAL",
      "BRICEÑO",
      "PEQUE",
      "DABEIBA",
      "CAMPAMENTO",
      "TOLEDO",
      "SABANALARGA",
      "URAMITA",
      "MURINDO",
      "SAN ANDRES",
      "CAÑASGORDAS",
      "BURITICA",
      "VEGACHI",
      "ANGOSTURA",
      "GUADALUPE",
      "FRONTINO",
      "SAN JOSE DE LA MONTAÑA",
      "GOMEZ PLATA",
      "SANTA ROSA DE OSOS",
      "VIGIA DEL FUERTE",
      "CAROLINA",
      "YOLOMBO",
      "LIBORINA",
      "BELMIRA",
      "YALI",
      "ABRIAQUI",
      "PUERTO BERRIO",
      "GIRALDO",
      "ENTRERRIOS",
      "OLAYA",
      "SANTAFE DE ANTIOQUIA",
      "MACEO",
      "SOPETRAN",
      "URRAO",
      "CISNEROS",
      "DON MATIAS",
      "SANTO DOMINGO",
      "SAN ROQUE",
      "CAICEDO",
      "BARBOSA",
      "SAN PEDRO",
      "SAN JERONIMO",
      "CARACOLI",
      "CONCEPCION",
      "GIRARDOTA",
      "COPACABANA",
      "BELLO",
      "EBEJICO",
      "ANZA",
      "ALEJANDRIA",
      "SAN RAFAEL",
      "MEDELLIN",
      "SAN VICENTE",
      "PEÑOL",
      "SAN CARLOS",
      "GUARNE",
      "GUATAPE",
      "BETULIA",
      "HELICONIA",
      "PUERTO NARE",
      "MARINILLA",
      "ARMENIA",
      "RIONEGRO",
      "GRANADA",
      "RETIRO",
      "ITAGUI",
      "ENVIGADO",
      "ANGELOPOLIS",
      "LA ESTRELLA",
      "CONCORDIA",
      "SABANETA",
      "EL SANTUARIO",
      "TITIRIBI",
      "EL CARMEN DE VIBORAL",
      "SAN LUIS",
      "CALDAS",
      "SALGAR",
      "COCORNA",
      "AMAGA",
      "LA CEJA",
      "LA UNION",
      "PUERTO TRIUNFO",
      "VENECIA",
      "SANTA BARBARA",
      "MONTEBELLO",
      "FREDONIA",
      "SAN FRANCISCO",
      "TARSO",
      "CIUDAD BOLIVAR",
      "ABEJORRAL",
      "SONSON",
      "PUEBLORRICO",
      "JERICO",
      "LA PINTADA",
      "HISPANIA",
      "TAMESIS",
      "BETANIA",
      "ANDES",
      "ARGELIA",
      "VALPARAISO",
      "JARDIN",
      "NARIÑO",
      "CARAMANTA",
      "MUTATA"
    ]
  },
  {
    "name": "CHOCO",
    "cities": [
      "ACANDI",
      "UNGUIA",
      "RIOSUCIO",
      "JURADO",
      "BOJAYA",
      "BAHIA SOLANO",
      "QUIBDO",
      "ALTO BAUDO",
      "NUQUI",
      "EL CARMEN DE ATRATO",
      "LLORO",
      "BAGADO",
      "BAJO BAUDO",
      "CANTON DEL SAN PABLO",
      "TADO",
      "CONDOTO",
      "ITSMINA",
      "NOVITA",
      "SAN JOSE DEL PALMAR",
      "SIPI",
      "EL LITORAL DEL SAN JUAN",
      "MEDIO ATRATO",
      "ATRATO",
      "RIO QUITO",
      "CERTEGUI",
      "UNION PANAMERICANA",
      "MEDIO BAUDO",
      "RIO IRO",
      "MEDIO SAN JUAN",
      "BELEN DE BAJIRA",
      "CARMEN DEL DARIEN"
    ]
  },
  {
    "name": "SANTANDER",
    "cities": [
      "PUERTO WILCHES",
      "RIONEGRO",
      "SABANA DE TORRES",
      "SURATA",
      "EL PLAYON",
      "CALIFORNIA",
      "VETAS",
      "MATANZA",
      "LEBRIJA",
      "CHARTA",
      "GIRON",
      "TONA",
      "BUCARAMANGA",
      "BARRANCABERMEJA",
      "SAN VICENTE DE CHUCURI",
      "FLORIDABLANCA",
      "BETULIA",
      "PIEDECUESTA",
      "SANTA BARBARA",
      "GUACA",
      "CERRITO",
      "ZAPATOCA",
      "SIMACOTA",
      "SAN ANDRES",
      "CONCEPCION",
      "LOS SANTOS",
      "EL CARMEN DE CHUCURI",
      "PUERTO PARRA",
      "ARATOCA",
      "CEPITA",
      "GALAN",
      "MALAGA",
      "CIMITARRA",
      "VILLANUEVA",
      "CARCASI",
      "JORDAN",
      "BARICHARA",
      "ENCISO",
      "MOLAGAVITA",
      "SAN JOSE DE MIRANDA",
      "CURITI",
      "CABRERA",
      "SAN GIL",
      "MOGOTES",
      "HATO",
      "SAN MIGUEL",
      "CAPITANEJO",
      "MACARAVITA",
      "PINCHOTE",
      "PALMAR",
      "SAN JOAQUIN",
      "ONZAGA",
      "VELEZ",
      "LANDAZURI",
      "SOCORRO",
      "SANTA HELENA DEL OPON",
      "PARAMO",
      "VALLE DE SAN JOSE",
      "CHIMA",
      "PALMAS DEL SOCORRO",
      "CONFINES",
      "OCAMONTE",
      "COROMORO",
      "CONTRATACION",
      "LA PAZ",
      "CHARALA",
      "GUAPOTA",
      "OIBA",
      "EL GUACAMAYO",
      "GUADALUPE",
      "BOLIVAR",
      "AGUADA",
      "ENCINO",
      "SUAITA",
      "EL PEÑON",
      "SAN BENITO",
      "CHIPATA",
      "SUCRE",
      "GUEPSA",
      "GAMBITA",
      "BARBOSA",
      "LA BELLEZA",
      "GUAVATA",
      "PUENTE NACIONAL",
      "JESUS MARIA",
      "FLORIAN",
      "ALBANIA"
    ]
  },
  {
    "name": "ARAUCA",
    "cities": [
      "ARAUCA",
      "SARAVENA",
      "ARAUQUITA",
      "FORTUL",
      "CRAVO NORTE",
      "TAME",
      "PUERTO RONDON"
    ]
  },
  {
    "name": "BOYACA",
    "cities": [
      "CUBARA",
      "CHISCAS",
      "GUICAN",
      "COVARACHIA",
      "EL ESPINO",
      "GUACAMAYAS",
      "SAN MATEO",
      "PANQUEBA",
      "TIPACOQUE",
      "BOAVITA",
      "EL COCUY",
      "SOATA",
      "LA UVITA",
      "CHITA",
      "SUSACON",
      "PUERTO BOYACA",
      "JERICO",
      "SATIVANORTE",
      "TUTAZA",
      "SOCOTA",
      "SANTANA",
      "SATIVASUR",
      "PAZ DE RIO",
      "SOCHA",
      "BELEN",
      "CHITARAQUE",
      "SAN JOSE DE PARE",
      "CERINZA",
      "PAIPA",
      "DUITAMA",
      "SANTA ROSA DE VITERBO",
      "BETEITIVA",
      "TOGUI",
      "MONIQUIRA",
      "TASCO",
      "FLORESTA",
      "OTANCHE",
      "CORRALES",
      "SOTAQUIRA",
      "BUSBANZA",
      "PISBA",
      "ARCABUCO",
      "GAMEZA",
      "PAYA",
      "PAUNA",
      "GACHANTIVA",
      "COMBITA",
      "NOBSA",
      "TIBASOSA",
      "SANTA SOFIA",
      "TOPAGA",
      "SABOYA",
      "SAN PABLO DE BORBUR",
      "MONGUA",
      "SOGAMOSO",
      "TUNUNGUA",
      "MONGUI",
      "CHIQUINQUIRA",
      "BRICEÑO",
      "TUTA",
      "VILLA DE LEYVA",
      "FIRAVITOBA",
      "SUTAMARCHAN",
      "MOTAVITA",
      "LABRANZAGRANDE",
      "CHIQUIZA",
      "MARIPI",
      "QUIPAMA",
      "OICATA",
      "AQUITANIA",
      "IZA",
      "TOCA",
      "SORA",
      "TUNJA",
      "TINJACA",
      "PESCA",
      "CHIVATA",
      "CALDAS",
      "SACHICA",
      "SAN MIGUEL DE SEMA",
      "MUZO",
      "CUITIVA",
      "RAQUIRA",
      "CUCAITA",
      "TOTA",
      "SAMACA",
      "SIACHOQUE",
      "LA VICTORIA",
      "BUENAVISTA",
      "COPER",
      "SORACA",
      "VIRACACHA",
      "RONDON",
      "BOYACA",
      "PAJARITO",
      "VENTAQUEMADA",
      "RAMIRIQUI",
      "CIENEGA",
      "JENESANO",
      "NUEVO COLON",
      "TIBANA",
      "TURMEQUE",
      "ZETAQUIRA",
      "SAN EDUARDO",
      "CHINAVITA",
      "BERBEO",
      "UMBITA",
      "MIRAFLORES",
      "PAEZ",
      "PACHAVITA",
      "GARAGOA",
      "LA CAPILLA",
      "CAMPOHERMOSO",
      "TENZA",
      "GUATEQUE",
      "MACANAL",
      "SUTATENZA",
      "SOMONDOCO",
      "ALMEIDA",
      "GUAYATA",
      "SAN LUIS DE GACENO",
      "SANTA MARIA",
      "CHIVOR"
    ]
  },
  {
    "name": "VICHADA",
    "cities": [
      "PUERTO CARREÑO",
      "LA PRIMAVERA",
      "SANTA ROSALIA",
      "CUMARIBO"
    ]
  },
  {
    "name": "CASANARE",
    "cities": [
      "HATO COROZAL",
      "LA SALINA",
      "SACAMA",
      "PAZ DE ARIPORO",
      "TAMARA",
      "PORE",
      "NUNCHIA",
      "SAN LUIS DE PALENQUE",
      "YOPAL",
      "TRINIDAD",
      "AGUAZUL",
      "RECETOR",
      "CHAMEZA",
      "OROCUE",
      "TAURAMENA",
      "MANI",
      "MONTERREY",
      "SABANALARGA",
      "VILLANUEVA"
    ]
  },
  {
    "name": "CUNDINAMARCA",
    "cities": [
      "YACOPI",
      "PUERTO SALGAR",
      "SIMIJACA",
      "CAPARRAPI",
      "SUSA",
      "GUACHETA",
      "FUQUENE",
      "CARMEN DE CARUPA",
      "PAIME",
      "LA PALMA",
      "GUADUAS",
      "SAN CAYETANO",
      "TOPAIPI",
      "UBATE",
      "LENGUAZAQUE",
      "VILLAGOMEZ",
      "VILLAPINZON",
      "EL PEÑON",
      "CUCUNUBA",
      "LA PEÑA",
      "PACHO",
      "SUTATAUSA",
      "TAUSA",
      "UTICA",
      "CHOCONTA",
      "SUESCA",
      "NIMAIMA",
      "VERGARA",
      "COGUA",
      "ZIPAQUIRA",
      "QUEBRADANEGRA",
      "NEMOCON",
      "MACHETA",
      "TIBIRITA",
      "SUPATA",
      "NOCAIMA",
      "VILLETA",
      "SESQUILE",
      "SUBACHOQUE",
      "LA VEGA",
      "MANTA",
      "GACHANCIPA",
      "SASAIMA",
      "SAN FRANCISCO",
      "TOCANCIPA",
      "CHAGUANI",
      "TABIO",
      "GUATAVITA",
      "CAJICA",
      "SAN JUAN DE RIO SECO",
      "VIANI",
      "SOPO",
      "ALBAN",
      "GACHETA",
      "GUAYABAL DE  SIQUIMA",
      "GUASCA",
      "EL ROSAL",
      "CHIA",
      "TENJO",
      "BITUIMA",
      "FACATATIVA",
      "UBALA",
      "MADRID",
      "COTA",
      "BELTRAN",
      "ANOLAIMA",
      "JUNIN",
      "LA CALERA",
      "ZIPACON",
      "QUIPILE",
      "FUNZA",
      "GACHALA",
      "GAMA",
      "BOJACA",
      "UBALA",
      "PULI",
      "CACHIPAY",
      "TENA",
      "PARATEBUENO",
      "MOSQUERA",
      "LA MESA",
      "FOMEQUE",
      "CHOACHI",
      "SAN ANTONIO DEL TEQUENDAMA",
      "JERUSALEN",
      "MEDINA",
      "SOACHA",
      "ANAPOIMA",
      "APULO",
      "EL COLEGIO",
      "TOCAIMA",
      "GUATAQUI",
      "UBAQUE",
      "GRANADA",
      "SIBATE",
      "VIOTA",
      "SILVANIA",
      "CHIPAQUE",
      "CAQUEZA",
      "NARIÑO",
      "GIRARDOT",
      "UNE",
      "AGUA DE DIOS",
      "PASCA",
      "FUSAGASUGA",
      "QUETAME",
      "TIBACUY",
      "RICAURTE",
      "FOSCA",
      "NILO",
      "GUTIERREZ",
      "ARBELAEZ",
      "GUAYABETAL",
      "PANDI",
      "SAN BERNARDO",
      "VENECIA",
      "CABRERA"
    ]
  },
  {
    "name": "CALDAS",
    "cities": [
      "AGUADAS",
      "PACORA",
      "VICTORIA",
      "PENSILVANIA",
      "RIOSUCIO",
      "MARMATO",
      "SUPIA",
      "SALAMINA",
      "LA MERCED",
      "FILADELFIA",
      "ARANZAZU",
      "MARULANDA",
      "MARQUETALIA",
      "MANZANARES",
      "ANSERMA",
      "NEIRA",
      "RISARALDA",
      "MANIZALES",
      "SAN JOSE",
      "PALESTINA",
      "VITERBO",
      "BELALCAZAR",
      "CHINCHINA",
      "VILLAMARIA",
      "LA DORADA",
      "NORCASIA",
      "SAMANA"
    ]
  },
  {
    "name": "RISARALDA",
    "cities": [
      "MISTRATO",
      "PUEBLO RICO",
      "QUINCHIA",
      "GUATICA",
      "BELEN DE UMBRIA",
      "APIA",
      "SANTUARIO",
      "LA CELIA",
      "MARSELLA",
      "BALBOA",
      "SANTA ROSA DE CABAL",
      "LA VIRGINIA",
      "PEREIRA",
      "DOSQUEBRADAS"
    ]
  },
  {
    "name": "TOLIMA",
    "cities": [
      "MARIQUITA",
      "HONDA",
      "FRESNO",
      "FALAN",
      "HERVEO",
      "PALOCABILDO",
      "ARMERO",
      "CASABIANCA",
      "VILLAHERMOSA",
      "LIBANO",
      "LERIDA",
      "AMBALEMA",
      "MURILLO",
      "VENADILLO",
      "SANTA ISABEL",
      "ANZOATEGUI",
      "ALVARADO",
      "IBAGUE",
      "PIEDRAS",
      "CAJAMARCA",
      "COELLO",
      "ROVIRA",
      "RONCESVALLES",
      "SAN LUIS",
      "FLANDES",
      "VALLE DE SAN JUAN",
      "MELGAR",
      "ICONONZO",
      "SUAREZ",
      "CARMEN DE APICALA",
      "ESPINAL",
      "GUAMO",
      "CUNDAY",
      "ORTEGA",
      "SAN ANTONIO",
      "CHAPARRAL",
      "PURIFICACION",
      "VILLARRICA",
      "SALDAÑA",
      "COYAIMA",
      "PRADO",
      "DOLORES",
      "RIOBLANCO",
      "NATAGAIMA",
      "ATACO",
      "ALPUJARRA",
      "PLANADAS"
    ]
  },
  {
    "name": "VALLE DEL CAUCA",
    "cities": [
      "EL AGUILA",
      "ANSERMANUEVO",
      "EL CAIRO",
      "CARTAGO",
      "ARGELIA",
      "ULLOA",
      "VERSALLES",
      "TORO",
      "ALCALA",
      "OBANDO",
      "LA UNION",
      "EL DOVIO",
      "LA VICTORIA",
      "ROLDANILLO",
      "ZARZAL",
      "SEVILLA",
      "BOLIVAR",
      "CAICEDONIA",
      "BUGALAGRANDE",
      "TRUJILLO",
      "BUENAVENTURA",
      "ANDALUCIA",
      "RIOFRIO",
      "TULUA",
      "SAN PEDRO",
      "DARIEN",
      "YOTOCO",
      "BUGA",
      "DAGUA",
      "RESTREPO",
      "VIJES",
      "GUACARI",
      "GINEBRA",
      "LA CUMBRE",
      "EL CERRITO",
      "PALMIRA",
      "YUMBO",
      "CALI",
      "PRADERA",
      "CANDELARIA",
      "FLORIDA",
      "JAMUNDI"
    ]
  },
  {
    "name": "META",
    "cities": [
      "PUERTO GAITAN",
      "BARRANCA DE UPIA",
      "SAN JUANITO",
      "EL CALVARIO",
      "CABUYARO",
      "RESTREPO",
      "PUERTO LOPEZ",
      "VILLAVICENCIO",
      "CUMARAL",
      "ACACIAS",
      "GUAMAL",
      "SAN LUIS DE CUBARRAL",
      "SAN CARLOS DE GUAROA",
      "CASTILLA LA NUEVA",
      "SAN MARTIN",
      "EL DORADO",
      "LA URIBE",
      "LEJANIAS",
      "EL CASTILLO",
      "GRANADA",
      "MESETAS",
      "FUENTE DE ORO",
      "PUERTO LLERAS",
      "MAPIRIPAN",
      "SAN JUAN DE ARAMA",
      "VISTAHERMOSA",
      "PUERTO RICO",
      "PUERTO CONCORDIA",
      "LA MACARENA"
    ]
  },
  {
    "name": "SANTAFE DE BOGOTA D.C",
    "cities": [
      "SANTAFE DE BOGOTA D.C."
    ]
  },
  {
    "name": "QUINDIO",
    "cities": [
      "FILANDIA",
      "SALENTO",
      "CIRCASIA",
      "QUIMBAYA",
      "MONTENEGRO",
      "ARMENIA",
      "CALARCA",
      "LA TEBAIDA",
      "CORDOBA",
      "BUENAVISTA",
      "PIJAO",
      "GENOVA"
    ]
  },
  {
    "name": "GUAINIA",
    "cities": [
      "INIRIDA",
      "CACAHUAL",
      "BARRANCO MINAS",
      "PUERTO COLOMBIA",
      "SAN FELIPE",
      "PANA PANA",
      "LA GUADALUPE",
      "MAPIRIPANA",
      "MORICHAL"
    ]
  },
  {
    "name": "HUILA",
    "cities": [
      "COLOMBIA",
      "VILLAVIEJA",
      "AIPE",
      "BARAYA",
      "NEIVA",
      "TELLO",
      "SANTA MARIA",
      "PALERMO",
      "TERUEL",
      "IQUIRA",
      "RIVERA",
      "NATAGA",
      "CAMPOALEGRE",
      "YAGUARA",
      "ALGECIRAS",
      "TESALIA",
      "HOBO",
      "GIGANTE",
      "LA PLATA",
      "PAICOL",
      "AGRADO",
      "PITAL",
      "GARZON",
      "LA ARGENTINA",
      "TARQUI",
      "OPORAPA",
      "SALADOBLANCO",
      "GUADALUPE",
      "SAN AGUSTIN",
      "ALTAMIRA",
      "ISNOS",
      "ELIAS",
      "SUAZA",
      "TIMANA",
      "PITALITO",
      "ACEVEDO",
      "PALESTINA"
    ]
  },
  {
    "name": "CAUCA",
    "cities": [
      "PUERTO TEJADA",
      "MIRANDA",
      "PADILLA",
      "LOPEZ",
      "CALOTO",
      "CORINTO",
      "SANTANDER DE QUILICHAO",
      "BUENOS AIRES",
      "TORIBIO",
      "TIMBIQUI",
      "SUAREZ",
      "PAEZ",
      "JAMBALO",
      "CALDONO",
      "TIMBIQUI",
      "MORALES",
      "EL TAMBO",
      "PIENDAMO",
      "SILVIA",
      "CAJIBIO",
      "GUAPI",
      "INZA",
      "TOTORO",
      "POPAYAN",
      "TIMBIO",
      "SOTARA",
      "PURACE",
      "ARGELIA",
      "PATIA",
      "ROSAS",
      "LA SIERRA",
      "BALBOA",
      "LA VEGA",
      "BOLIVAR",
      "SAN SEBASTIAN",
      "ALMAGUER",
      "MERCADERES",
      "SANTA ROSA",
      "FLORENCIA",
      "PIAMONTE",
      "SUCRE",
      "VILLA RICA"
    ]
  },
  {
    "name": "CAQUETA",
    "cities": [
      "SAN VICENTE DEL CAGUAN",
      "PUERTO RICO",
      "EL DONCELLO",
      "FLORENCIA",
      "EL PAUJIL",
      "LA MONTAÑITA",
      "BELEN DE LOS ANDAQUIES",
      "MORELIA",
      "SAN JOSE DEL FRAGUA",
      "CARTAGENA DEL CHAIRA",
      "VALPARAISO",
      "MILAN",
      "ALBANIA",
      "CURILLO",
      "SOLANO",
      "SOLITA"
    ]
  },
  {
    "name": "GUAVIARE",
    "cities": [
      "SAN JOSE DEL GUAVIARE",
      "EL RETORNO",
      "CALAMAR",
      "MIRAFLORES"
    ]
  },
  {
    "name": "NARIÑO",
    "cities": [
      "SANTA BARBARA",
      "EL CHARCO",
      "MOSQUERA",
      "LA TOLA",
      "OLAYA  HERRERA",
      "FRANCISCO PIZARRO",
      "ROBERTO PAYAN",
      "MAGUI",
      "LEIVA",
      "TUMACO",
      "POLICARPA",
      "EL ROSARIO",
      "CUMBITARA",
      "BARBACOAS",
      "LOS ANDES",
      "SAN PABLO",
      "TAMINANGO",
      "COLON",
      "LA UNION",
      "SAN LORENZO",
      "LA CRUZ",
      "BELEN",
      "LA LLANADA",
      "SAN PEDRO DE CARTAGO",
      "SAN BERNARDO",
      "ALBAN",
      "ARBOLEDA",
      "SAMANIEGO",
      "EL TAMBO",
      "CHACHAGUI",
      "EL TABLON",
      "LINARES",
      "RICAURTE",
      "BUESACO",
      "SANTA CRUZ",
      "LA FLORIDA",
      "SANDONA",
      "PASTO",
      "PROVIDENCIA",
      "MALLAMA",
      "ANCUYA",
      "TUQUERRES",
      "CONSACA",
      "GUAITARILLA",
      "YACUANQUER",
      "TANGUA",
      "IMUES",
      "SAPUYES",
      "FUNES",
      "CUMBAL",
      "OSPINA",
      "GUACHUCAL",
      "ILES",
      "PUPIALES",
      "GUALMATAN",
      "ALDANA",
      "CONTADERO",
      "PUERRES",
      "CUASPUD",
      "CORDOBA",
      "IPIALES",
      "POTOSI",
      "EL PEÑOL",
      "NARIÑO"
    ]
  },
  {
    "name": "VAUPES",
    "cities": [
      "PAPUNAUA",
      "CARURU",
      "MITU",
      "YAVARATE",
      "PACOA",
      "TARAIRA"
    ]
  },
  {
    "name": "PUTUMAYO",
    "cities": [
      "MOCOA",
      "SAN FRANCISCO",
      "SIBUNDOY",
      "COLON",
      "SANTIAGO",
      "VILLAGARZON",
      "PUERTO GUZMAN",
      "ORITO",
      "PUERTO CAICEDO",
      "PUERTO LEGUIZAMO",
      "PUERTO ASIS",
      "VALLE DEL GUAMUEZ",
      "SAN MIGUEL"
    ]
  },
  {
    "name": "AMAZONAS",
    "cities": [
      "MIRITI-PARANA",
      "PUERTO SANTANDER",
      "LA CHORRERA",
      "LA PEDRERA",
      "EL ENCANTO",
      "TARAPACA",
      "LETICIA",
      "PUERTO NARIÑO",
      "LA VICTORIA",
      "PUERTO ARICA",
      "PUERTO ALEGRIA"
    ]
  },
  {
    "name": "ARCHIPIELAGO DE SAN ANDRES PROVIDENCIA Y SANTA CATALINA",
    "cities": [
      "SAN ANDRES",
      "SANTA CATALINA",
      "PROVIDENCIA"
    ]
  }
]